// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__qSFmK","Cancel":"schedule_Cancel__1FbFE"};